import { t } from 'i18next';
import { useState } from 'react';

import ConfirmationDialog from '~components/Dialog/ConfirmationDialog';
import { TreadAgentSkillBasic } from '~hooks/useTreadAgent/models';
import useTreadAgentSkills from '~hooks/useTreadAgentSkills/useTreadAgentSkills';

interface TreadAgentSkillDeleteDialogProps {
  companyId: string;
  onClose: () => void;
  onDeleted?: () => void;
  skill: Pick<TreadAgentSkillBasic, 'id' | 'name'> | null;
}

export default function TreadAgentSkillDeleteDialog({
  companyId,
  onClose,
  onDeleted,
  skill,
}: TreadAgentSkillDeleteDialogProps) {
  const { deleteSkill } = useTreadAgentSkills();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!skill?.id) {
      return;
    }

    setIsDeleting(true);

    try {
      await deleteSkill(companyId, skill.id);
      onClose();
      onDeleted?.();
    } catch {
      // Already reported by the hook.
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <ConfirmationDialog
      confirmButtonProps={{ children: t('actions.delete') }}
      isBusy={isDeleting}
      isOpen={Boolean(skill)}
      onClose={() => {
        if (!isDeleting) {
          onClose();
        }
      }}
      onConfirm={handleDelete}
      title={t('tread_agent.skills.delete_title')}
    >
      {t('tread_agent.skills.delete_message', { name: skill?.name })}
    </ConfirmationDialog>
  );
}
